/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class DasUBootGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_WIN_WAYS_TOP = "WinWaysTop";
    static BITMAP_FONT_WIN_WAYS_BOTTOM = "WinWaysBottom";
    static BITMAP_FONT_MULTIPLIER:string = "Multiplier";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FREE_SPIN_BACKGROUND:string = "freespinBackground";
    public static SUPER_FREE_SPIN_BACKGROUND:string = "superFreespinBackground";
    public static BACKGROUND_VIGNETTE:string = "bGFx/bgVignette";

    public static VIGNETTE:string = "vignette";

    static REEL_FRAME_BACKGROUND:string = "reelFrame/frameBg";
    static REEL_FRAME_TOP:string = "reelFrame/frameTopPart";


    static PERISCOPE_BACKGROUND:string = "periscopeFeature/periscopeTube";
    static PERISCOPE_HEAD:string = "periscopeFeature/periscopeHead";
    static PERISCOPE_CROSS_HAIR:string = "periscopeFeature/periscopeCrosshair";
    static PERISCOPE_SPINE:string = "spine/periscope.json";

    static FS_TRANSITIONS:string = "spine/FreespinTransitions.json";


    static XBOMB_METER_SPINE:string = "spine/xBombMeter.json";
    static CREW_REACTIONS_SPINE:string = "spine/crewReactions.json";
    static TORPEDO_BUBBLES_SPINE:string = "spine/torpedoLaunchBubbles.json";
    static STACKED_WILD_SPINE:string = "spine/SplittingTheNudgingWilds.json";
    static BIG_WIN_SPINE:string = "spine/bigWin.json";
    static SYMBOL_EXPLOSION_SPINE:string ="spine/collapsingSymbol.json" ;
    static BOMB_SYMBOL_SPINE:string = "spine/BombWild.json" ;
    static BOMB_SYMBOL_EXPLOSION_SPINE:string = "spine/BombWildExplosion.json" ;
    static SCATTER_SYMBOL_SPINE:string = "spine/ScatterSymbol.json" ;
    static PERISCOPE_SYMBOL_SPINE:string = "spine/periscopeWild.json" ;
    static FRAME_SPINE:string = "spine/frameRoot.json";
    static BG_SPINE:string = "spine/Background.json";
    static SMALL_EXPLOSION:string = "spine/smallExplosion.json";


    static AVALANCHE_ATTENTION:string = "nearWin/avalancheAttention";
    static AVALANCHE_REEL_ATTENTION:string = "AVALANCHE_REEL_ATTENTION";


    static LAMP_X_NUDGE:string = "spine/xNudgeLamp.json";
    static LAMP_X_WAYS:string = "spine/xWayLamp.json";
    static LAMP_LEFT:string = "spine/leftLamp.json";
    static LAMP_RIGHT:string = "spine/rightLamp.json";



    static SYMBOL_GLOW_FRAME:string = "winFrame/glowFrame";
    static SYMBOL_GLOW_DOT:string = "winFrame/glowDot";
    static SHARP_SYMBOL_FRAME:string = "winFrame/sharpFrame";
    static SYMBOL_GLOW_SONAR_SWEEP:string = "winFrame/glowSonarSweep";

    static SHARP_RING:string = "ringSharp";
    static PLUS2:string = "S/plus2";

    public static TORPEDO_BACKGROUND:string = "torpedo/torpedoBg"
    public static TORPEDO_BACKGROUND_HATCH:string = "torpedo/hatch"
    static TORPEDO_PART_BACKGROUND:string = "torpedo/torpedoPartBg";
    static TORPEDO_PART_x1:string = "torpedo/1";
    static TORPEDO_PART_x2:string = "torpedo/2";
    static TORPEDO_PART_x3:string = "torpedo/3";
    static TORPEDO_PART_x4:string = "torpedo/4";
    static TORPEDO_PART_x5:string = "torpedo/5";
    static TORPEDO_PART_x6:string = "torpedo/6";
    static TORPEDO_PART_x7:string = "torpedo/7";
    static TORPEDO_PART_x8:string = "torpedo/8";
    static TORPEDO_PART_x9:string = "torpedo/9";
    static TORPEDO_PART_XWAYS_LOGO:string = "torpedo/xWays";
    static TORPEDO_PART_XWILD_LOGO:string = "torpedo/xWild";
    static TORPEDO_BLANK:string = "torpedo/torpedoBlank";
    static TORPEDO_PROPELLER_STILL:string = "torpedo/propellerStill";
    static TORPEDO_PROPELLER:string = "TORPEDO_PROPELLER";

    static GOLD_BAR:string = "bigWin/goldbar";
    static GOLD_BAR_GLOW:string = "bigWin/goldbarGlow";

    static WIN_WAYS_COUNTER_BG:string = "winWays/numberBg";
    static WIN_WAYS_COUNTER_NUMBERS:string = "winWays/numbers";
    static WIN_WAYS_COUNTER_OVERLAY:string = "winWays/numberOverlay";

    static MULTIPLIER_COUNTER_BACKGROUND:string = "xBombCounter/xBombCounterDisplay";
    static MULTIPLIER_COUNTER_BG:string = "xBombCounter/xBombCounterBackground";
    static MULTIPLIER_COUNTER_NUMBERS:string = "xBombCounter/xBombCounterNumbers";
    static MULTIPLIER_COUNTER_OVERLAY:string = "xBombCounter/xBombCounterOverlay";

    static REEL_COVER:string = "transitions/reelCover";
    static FLASH:string = "xBombCounter/flash";




    public static getSymbolStateTexturePath(symbolName:string, stateName:string = ""):string {

        if (symbolName == "WP"){
            return "W/" + symbolName + "" + stateName;
        }

        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro:[],

        main:[
            {
                name:"fonts",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new BitmapFontAsset(DasUBootGameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapfonts/Multiplier.fnt"),
                    new BitmapFontAsset(DasUBootGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(DasUBootGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(DasUBootGameAssets.BITMAP_FONT_WIN_WAYS_TOP, "fonts/bitmapfonts/WinWaysTop.fnt"),
                    new BitmapFontAsset(DasUBootGameAssets.BITMAP_FONT_WIN_WAYS_BOTTOM, "fonts/bitmapfonts/WinWaysBottom.fnt")
                ]
            },
            {
                name:"backgrounds",
                assets:[
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json")
                ]
            },
            {
                name:"spine",
                assets:[
                    new SpineAsset(DasUBootGameAssets.PERISCOPE_SPINE, DasUBootGameAssets.PERISCOPE_SPINE),
                    new SpineAsset(DasUBootGameAssets.BOMB_SYMBOL_SPINE, DasUBootGameAssets.BOMB_SYMBOL_SPINE),
                    new SpineAsset(DasUBootGameAssets.BOMB_SYMBOL_EXPLOSION_SPINE, DasUBootGameAssets.BOMB_SYMBOL_EXPLOSION_SPINE),
                    new SpineAsset(DasUBootGameAssets.SCATTER_SYMBOL_SPINE, DasUBootGameAssets.SCATTER_SYMBOL_SPINE),
                    new SpineAsset(DasUBootGameAssets.PERISCOPE_SYMBOL_SPINE, DasUBootGameAssets.PERISCOPE_SYMBOL_SPINE),
                    new SpineAsset(DasUBootGameAssets.SYMBOL_EXPLOSION_SPINE, DasUBootGameAssets.SYMBOL_EXPLOSION_SPINE),
                    new SpineAsset(DasUBootGameAssets.BIG_WIN_SPINE, DasUBootGameAssets.BIG_WIN_SPINE),
                    new SpineAsset(DasUBootGameAssets.FS_TRANSITIONS, DasUBootGameAssets.FS_TRANSITIONS),
                    new SpineAsset(DasUBootGameAssets.STACKED_WILD_SPINE, DasUBootGameAssets.STACKED_WILD_SPINE),
                    new SpineAsset(DasUBootGameAssets.LAMP_X_NUDGE, DasUBootGameAssets.LAMP_X_NUDGE),
                    new SpineAsset(DasUBootGameAssets.LAMP_X_WAYS, DasUBootGameAssets.LAMP_X_WAYS),
                    new SpineAsset(DasUBootGameAssets.LAMP_LEFT, DasUBootGameAssets.LAMP_LEFT),
                    new SpineAsset(DasUBootGameAssets.LAMP_RIGHT, DasUBootGameAssets.LAMP_RIGHT),
                    new SpineAsset(DasUBootGameAssets.TORPEDO_BUBBLES_SPINE, DasUBootGameAssets.TORPEDO_BUBBLES_SPINE),
                    new SpineAsset(DasUBootGameAssets.CREW_REACTIONS_SPINE, DasUBootGameAssets.CREW_REACTIONS_SPINE),
                    new SpineAsset(DasUBootGameAssets.XBOMB_METER_SPINE, DasUBootGameAssets.XBOMB_METER_SPINE),
                    new SpineAsset(DasUBootGameAssets.FRAME_SPINE, DasUBootGameAssets.FRAME_SPINE),
                    new SpineAsset(DasUBootGameAssets.BG_SPINE, DasUBootGameAssets.BG_SPINE),
                    new SpineAsset(DasUBootGameAssets.SMALL_EXPLOSION, DasUBootGameAssets.SMALL_EXPLOSION),
                ]
            },
            {
                name:"main",
                assets:[
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    //new TextureAsset("main5", "sheets/main/main5.json"),
                ],
                animations:{
                    [DasUBootGameAssets.TORPEDO_PROPELLER]:"torpedo/propeller/propeller_"
                }
            },
            {
                name:"mainJpeg",
                assets:[
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json")
                ],
                animations:{
                    [DasUBootGameAssets.AVALANCHE_REEL_ATTENTION]:"reelEffect/eff_anticipation_"
                }
            },
            {
                name:"symbols",
                assets:[
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            }
        ]
    };
}